import SmartLinkApp from "./SmartLinkApp";

// Inner routes are *relative* to /:companyId/:planId — react-router v6
// resolves these against the parent splat from src/router/routes.tsx.
const routes = [
  {
    key: "smart_links",
    route: "smart_links",
    component: <SmartLinkApp />,
  }
];

export default routes;
